export { nanoid } from '../../core/transport.js'
export type RuleId = string
export const RuleId = (prop: any) => (typeof prop === 'string' ? prop : null)
RuleId.isValid = (prop: any) => typeof prop === 'string'
